let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lP2Aa")).then(() => parcelRequire('1tcJ6'));